import { Injectable } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { IFormSchemaItem } from '../../types/datatypes';
import { CoreModule } from '../core.module';

@Injectable({
	providedIn: CoreModule,
})
export class FormSchemaService {
	formGroupFromSchemas(schemas: IFormSchemaItem[]) {
		const schemaFormFields = {};
		schemas.forEach((questionSchema) => {
			const validators: ValidatorFn[] = [];
			let initialValue: any;
			switch (questionSchema.type) {
				case 'text':
				case 'textarea':
				case 'select':
				default:
					initialValue = '';
					break;
				case 'number':
					initialValue = 1;
					break;
			}
			if (questionSchema.required) {
				validators.push(Validators.required);
			}
			if (questionSchema.maxLength) {
				validators.push(Validators.maxLength(questionSchema.maxLength));
			}
			if (questionSchema.maxValue) {
				validators.push(Validators.max(questionSchema.maxValue));
			}
			schemaFormFields[questionSchema.name] = [initialValue, validators];
		});
		return schemaFormFields;
	}
}
